export default "__VITE_ASSET__BfvDKD88__"